<template>
  <v-row class="pb-8 pb-md-0">
    <v-col cols="auto" class="pr-3">
      <BaseButton
        color="whiteSmoke"
        width="14"
        height="30"
        icon
        @click="previousStep"
      >
        <v-icon color="primary" size="14"> fa-chevron-left </v-icon>
      </BaseButton>
    </v-col>
    <v-col cols="10">
      <p class="gray--text" style="margin-top: 2px;">
        VOLTAR
      </p>
    </v-col>
    <v-col cols="10">
      <p class="gray--text font-weight-bold quotation-title">
        TIPO DE RECURSO
      </p>
    </v-col>
    <v-col cols="12" md="4">
      <BaseFormInput
        id-element="selectedEmissionTypeQuotation"
        v-model="nameSelectedEmissionType"
        disabled
        label-text="Tipo de Emissão"
      />
    </v-col>
    <v-spacer />
    <v-col cols="12" md="4" class="align-self-center">
      <div
        class="quotation-disclaimer__div yellow d-flex align-center justify-center"
      >
        <p
          class="primary--text mb-0 font-weight-bold quotation-disclaimer__text"
        >
          *Valor referente à cobertura máxima do produto
        </p>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  computed: {
    nameSelectedEmissionType() {
      return (
        this.form.emissionType &&
        `${this.form.emissionType.nome} - ${this.form.emissionType.subtitulo}`
      );
    }
  },
  methods: {
    previousStep() {
      this.$emit("return");
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
<style lang="sass" scoped>
.quotation-disclaimer__
  &text
    font-size: 12px
  &div
    border-radius: 4px
    height: 40px
</style>
